export default __webpack_public_path__ + "static/media/icon-arrow-back.a41af95e.svg";